"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECKeyPair = exports.verifySignature = exports.recoverPubKey = exports.sha256 = exports.rmd160 = void 0;
const secp256k1_1 = require("@noble/curves/secp256k1");
const ripemd160_1 = require("@noble/hashes/ripemd160");
const sha256_1 = require("@noble/hashes/sha256");
const bytes_1 = require("./bytes");
function rmd160(data) {
    const buffer = typeof data === 'string' ? bytes_1.JuneoBuffer.fromString(data, 'hex') : data;
    return bytes_1.JuneoBuffer.fromBytes(Buffer.from((0, ripemd160_1.ripemd160)(buffer.getBytes())));
}
exports.rmd160 = rmd160;
function sha256(data) {
    const buffer = typeof data === 'string' ? bytes_1.JuneoBuffer.fromString(data, 'hex') : data;
    return bytes_1.JuneoBuffer.fromBytes(Buffer.from((0, sha256_1.sha256)(buffer.getBytes())));
}
exports.sha256 = sha256;
function recoverPubKey(signature, message) {
    const sig = parseSignature(signature);
    const bytes = Buffer.from(sig.recoverPublicKey((0, sha256_1.sha256)(message.getBytes())).toRawBytes(true));
    return bytes_1.JuneoBuffer.fromBytes(bytes).toHex();
}
exports.recoverPubKey = recoverPubKey;
function verifySignature(signature, message, publicKey) {
    return secp256k1_1.secp256k1.verify(parseSignature(signature), (0, sha256_1.sha256)(message.getBytes()), publicKey);
}
exports.verifySignature = verifySignature;
function parseSignature(signature) {
    const bytes = signature.serialize().getBytes();
    const sig = secp256k1_1.secp256k1.Signature.fromCompact(bytes.subarray(0, 64));
    return sig.addRecoveryBit(signature.v);
}
class ECKeyPair {
    privateKey;
    publicKey;
    constructor(privateKey) {
        this.privateKey = privateKey;
        this.publicKey = bytes_1.JuneoBuffer.fromBytes(Buffer.from(secp256k1_1.secp256k1.getPublicKey(privateKey, true))).toHex();
    }
    sign(message) {
        const signature = secp256k1_1.secp256k1.sign((0, sha256_1.sha256)(message.getBytes()), this.privateKey);
        return bytes_1.JuneoBuffer.fromString(`${signature.toCompactHex()}${signature.recovery.toString(16).padStart(2, '0')}`);
    }
}
exports.ECKeyPair = ECKeyPair;
